import { faCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";

import { PublicProtectionProfile } from "api/public/protectionProfiles/protectionProfiles.types";

interface StatusCellProps {
  row: PublicProtectionProfile;
}

const StatusCell = ({ row }: StatusCellProps) => {
  const isArchived =
    row.sunset_date && moment(row.sunset_date).isBefore(moment());
  const isApproved = row.status === "Publishing";

  const statusText = isArchived ? "Archived" : "Approved";
  const color = isArchived ? "orange" : isApproved ? "green" : "yellow";

  return (
    <>
      <FontAwesomeIcon
        icon={faCircle}
        className="me-1"
        color={`var(--bs-${color})`}
        size="xs"
      />
      <span
        style={{
          overflow: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
        }}
      >
        {statusText}
      </span>
    </>
  );
};

export default StatusCell;
